import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/EndPoint";
import StaffIcon from "../../Icons/StaffIcon";
import useGetHook from "../../customHooks/useGetHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const StaffListComponent = loadable(
  () => import("../../components/Staff/StaffList")
);

const StaffList = () => {
  const { data: profile, isLoading } = useGetHook({
    queryKey: ["user-profile"],
    url: `${APIS.USER}me/`,
    params: {},
  });
  const { mutateAsync: patchUser } = usePatchHook({
    queryKey: ["staff"],
    navigateURL: null,
  });

  const handleIsActive = async (value: boolean, id: any) => {
    const payload = {
      is_overtime_allowed: value,
    };
    const url = `${APIS.STAFF_INFO}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <StaffIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Staff</span>
      </div>
      <StaffListComponent handleIsActive={handleIsActive} profile={profile} />
    </>
  );
};

export default StaffList;
